import { defineStore } from 'pinia'

import type MenuCategory from '../classes/MenuCategory';
import type CuratedPack from '../types/CuratedPack';
import type Product from '../classes/Product';
import MenuService from '../services/Menu';

import { useBasketStore } from './basket';

// export const useUserStore = defineStore('user', () => {
export const useMenuStore = defineStore({
  id: "menuStore",
  state: () => ({
    menuLocation: null as (number | null),
    menu: [] as MenuCategory[]
  }),
  getters: {
    getMenu(state){
      return state.menu
    },
    getFilteredMenu(state) {
      if (state.menu) {
        const filteredMenu = state.menu.filter((cat: MenuCategory) => {
          return cat.isCatering()
        })

        return filteredMenu;
      } else {
        return [] as MenuCategory[];
      }
    },
  },
  actions: {
    setMenuLocation(rid: number) {
      this.menuLocation = rid;
    },
    setMenu(categories: MenuCategory[]) {
      this.menu = categories;
    },
    fetchMenu(rid: number): Promise<any>  {
      return new Promise((resolve, reject) => {
        if (rid == this.menuLocation) {
          if (this.menu && this.menu.length > 0) {
            resolve(this.menu); // already have it
          } else {
            MenuService.getAll(rid).then((resp) => {              
              this.menu = resp;
              this.menuLocation = rid;
              resolve(resp);
            });
          }
        } else {
          // Its a different store's menu so clear the old one immediately
          this.menu = [] as MenuCategory[];
          MenuService.getAll(rid).then((resp) => {
            this.menuLocation = rid;
            this.menu = resp;
            resolve(resp);
          });
        }
      })
    },
    getProductByChainId(chainproductid: string): Promise<any> {
      return new Promise((resolve, reject) => {
        this.getChainProductKeyedProducts(this.menuLocation!).then((products: any) => {
          const prod = products.get(chainproductid);
          resolve(prod);
        })
      });
    },
    fetchProduct(id: number): Promise<any> {
      // Merge the option groups onto the currently stored product
      return new Promise((resolve, reject) => {
        if (this.menuLocation) {
          MenuService.getProduct(this.menuLocation!, id).then((resp) => {
            this.menu.forEach((menuCategory: MenuCategory) => {
              if (menuCategory.products) {
                menuCategory.products.forEach((product: Product) => {
                  if (product.id == id.toString()) {
                    product.optiongroups = resp.optiongroups
                    resolve(product);
                  }
                })
              }
            })
          })
        }
      })
    },
    getIdKeyedProducts(rid: number): Promise<any> {
      const products = new Map();
      // Returns a hash of products keyed by product id
      return new Promise((resolve, reject) => {
        if (this.menu && this.menu.length > 0) {
          this.menu.forEach((cat: MenuCategory) => {
            if (cat.products) {
              cat.products.forEach((prod: Product) => {
                products.set(prod.id.toString(), prod);
              })
              resolve(products);
            }
          })
        } else {
          this.fetchMenu(rid).then((menu: MenuCategory[]) => {
            if (menu) {
              this.menu.forEach((cat: MenuCategory) => {
                if (cat.products) {
                  cat.products.forEach((prod: Product) => {
                    products.set(prod.id.toString(), prod);
                  })
                  resolve(products);
                }
              })
            }
          });
        }
      })
    },
    getChainProductKeyedProducts(rid: number): Promise<any> {
      const products = new Map();
      // Returns a hash of products keyed by product id
      return new Promise((resolve, reject) => {
        if (this.menu && this.menu.length > 0) {
          this.menu.forEach((cat: MenuCategory) => {
            if (cat.products) {
              cat.products.forEach((prod: Product) => {
                products.set(prod.chainproductid.toString(), prod);
              })
              resolve(products);
            }
          })
        } else {
          this.fetchMenu(rid).then((menu: MenuCategory[]) => {
            if (menu) {
              this.menu.forEach((cat: MenuCategory) => {
                if (cat.products) {
                  cat.products.forEach((prod: Product) => {
                    products.set(prod.chainproductid.toString(), prod);
                  })
                  resolve(products);
                }
              })
            }
          });
        }
      })
    },
    getProduct(id: number): Promise<any> {
      // We'll loop through the products in the menu and if the item contains option groups, we'll return it
      return new Promise((resolve, reject) => {
        // Flatten the products out of the categories so we can find specific one
        const products = [] as Product[];
        let product = null;

        // TODO: Make sure the menu is set and has categories, or fetch it first
        this.menu.forEach((category) => {
          if (category.products) {
            category.products.forEach((prod) => {
              products.push(prod)
            })
          }
        })

        if (products) {
          product = products.find((prod) => {
            return prod.id == id.toString()
          })
        }

        if (product && product.optiongroups) {
          resolve(product)
        } else {
          this.fetchProduct(id).then((product: Product) => {
            resolve(product)
          })
        }
      })
    },
    // Recommendations
    fetchRecommendations(): Promise<any>  {
      return new Promise((resolve, reject) => {
        let st = this;
        MenuService.getRecommendations(this.menuLocation!, 'fake-basket-string-here').then((products: Product[]) => {
          window.setTimeout(function() {
            resolve(products as Product[])
          }, 2500);
        })
        // if (rid == this.menuLocation) {
        //   if (this.menu && this.menu.length > 0) {
        //     // Do we just do nothing?
        //   } else {
        //     MenuService.getAll(rid).then((resp) => {
        //       this.menu = resp;
        //       resolve(resp);
        //     });
        //   }
        // } else {
        //   // Its a different store's menu so clear the old one immediately
        //   this.menu = [] as MenuCategory[];
        //   MenuService.getAll(rid).then((resp) => {
        //     this.menuLocation = rid;
        //     this.menu = resp;
        //     resolve(resp);
        //   });
        // }
      })
    },
  }
})
